import { render } from "./MobileHeader.vue?vue&type=template&id=b98a749a&ts=true"
import script from "./MobileHeader.vue?vue&type=script&lang=ts"
export * from "./MobileHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__